/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-10 16:48:01
 * @LastEditTime: 2022-01-12 14:35:12
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 数币对账单
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/SZRMBList/index.jsx
 */
import React, { useRef } from 'react'
import AuthButton from '../../../components/AuthButton/AuthButton'
import TableHelper from '../../../components/TableHelper'
import { fetchPlatformRecordSzRmbPayOrderSummaryDataList } from '../../../services/platformAccountingRecord'
import { formatTime } from '../../../utils'
import SzRmbPayOrderSummaryDataOrderList from './components/SzRmbPayOrderSummaryDataOrderListModal'
const SZRMBList = (props) => {
    let SzRmbPayOrderSummaryDataOrderListRef = useRef()
    const columns = [
        { title: '交易日期', dataIndex: 'tradeDate', render: text => formatTime(text, 'YYYY-MM-DD') },
        { title: '交易笔数', dataIndex: 'tradeNum' },
        { title: '交易金额', dataIndex: 'tradeAmount' },
        { title: '手续费', dataIndex: 'serviceCharge' },
        { title: '交易净额', dataIndex: 'liquidationAmount' },
        { title: '出单日期', dataIndex: 'issuanceDate', render: text => formatTime(text, 'YYYY-MM-DD') },
        { title: 'DC/EP交易笔数', dataIndex: 'dcEpTradeNum' },
        { title: 'DC/EP交易金额', dataIndex: 'dcEpTradeAmount' },
        { title: '对账文件名称', dataIndex: 'fileName', render: (text, record) => {
            return <a href={record.fileUrl} download target="view_frame">{text}</a>
        } },
        { title: '创建时间', dataIndex: 'createTime', render: text => formatTime(text, 'YYYY-MM-DD HH:mm') },
        { title: '操作', dataIndex: 'action', render: (text, record) => {
            return (
                <AuthButton authkey="e-14-1">
                    <a onClick={() =>SzRmbPayOrderSummaryDataOrderListRef.open(record.id)}>详情</a>
                </AuthButton>
            )
        }  }
    ]

    const searchOptions = [
        { key: 'startDate', type: 'date', placeholder: '开始日期' },
        { key: 'endDate', type: 'date', placeholder: '结束日期' },
    ]
    return (
        <div>
            <TableHelper columns={columns} searchOptions={searchOptions} request={fetchPlatformRecordSzRmbPayOrderSummaryDataList} />
            <SzRmbPayOrderSummaryDataOrderList getRef={ref => SzRmbPayOrderSummaryDataOrderListRef = ref} />
        </div>
    )
}

export default SZRMBList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/SZRMBList/index.jsx